<template>
    <div class="rm-files__content">
        <div v-if="report && report.name" class="rm-files__content">
            <div class="v-list">
                <div class="v-list__group">
                    <div class="rm-files__filebox">
                        <a href="#" @click.prevent="download()" class="rm-files__filename" v-html="report.name"></a>
                    </div>
                </div>
            </div>
        </div>

        <strong v-else class="rm-files__msg r-strong">Здесь будет показан отчёт по консультации</strong>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: "Report",
        computed: {
            ...mapState(['consultation']),
            ...mapState('report', [
                'report',
            ])
        },
        mounted() {
            window.echo.private('consultation.room.' + this.consultation.id).listen('Report.AddReport', ({report}) => {
                this.setReport(report);
            });

            this.getReport(window.laravel.consultation.id);
        },
        methods: {
            ...mapActions('report', [
                'getReport'
            ]),
            ...mapMutations('report', [
                'setReport',
                'spliceReport'
            ]),
            download() {
                const type = this.report.name.split(".").pop();

                if (['pdf', 'png', 'jpeg', 'jpg', 'doc', 'docx'].indexOf(type) !== -1) {
                    if (['png', 'jpeg', 'jpg'].indexOf(type) !== -1) {
                        window.open('/storage/room/' + this.report.path, 'Show', "width=700,height=600,left=200,top=50;");
                    } else {
                        window.open('/report/show/' + this.consultation.id + '/' + this.report.name, 'Show', "width=700,height=600,left=200,top=50;");
                    }
                } else {
                    window.open('/report/ '+ this.consultation.id + '/download/', 'Download');
                }
            }
        }
    }
</script>
